import React, { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Notifications from './components/Notifications';
import DailyProgress from './components/DailyProgress';
import AccountManagement from './components/AccountManagement';
import MyCoach from './components/MyCoach';
import MyDocuments from './components/MyDocuments';
import ChartsGraphs from './components/ChartsGraphs';
import Settings from './components/Settings';
import FoodLog from './components/FoodLog';
import { LanguageProvider } from './context/LanguageContext';
import { GlucoseProvider } from './context/GlucoseContext';
import { useAuth } from "react-oidc-context";
import { useUser } from './context/UserContext';
import AccountCreation from './components/AccountCreation';

function App() {
  const auth = useAuth();
  const { userData, isLoading: isUserLoading } = useUser();
  const [currentPage, setCurrentPage] = useState<string>('dashboard');

  // const signOutRedirect = () => {
  //   const clientId = "663f72imdfg1pjftfglc2560tt";
  //   const logoutUri = "<logout uri>";
  //   const cognitoDomain = "https://<user pool domain>";
  //   window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  // };

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading && !auth.error && !auth.activeNavigator) {
      auth.signinRedirect();
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.error, auth.activeNavigator, auth]);

  if (auth.isLoading || isUserLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (!auth.isAuthenticated) {
    return <div>Redirecting to login...</div>;
  }

  if (!userData) {
    return <AccountCreation />;
  }


  const renderPage = () => {
    switch (currentPage) {
      case 'account':
        return <AccountManagement />;
      case 'progress':
        return <DailyProgress />;
      case 'coach':
        return <MyCoach />;
      case 'documents':
        return <MyDocuments />;
      case 'charts':
        return <ChartsGraphs />;
      case 'foodlog':
        return <FoodLog />;
      case 'notifications':
        return <Notifications />;
      case 'settings':
        return <Settings />;
      case 'dashboard':
      default:
        return <Dashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <LanguageProvider>
      <GlucoseProvider>
        <div className="app">
          <Sidebar currentPage={currentPage} onNavigate={setCurrentPage} />
          <main className="main-content">
            {renderPage()}
          </main>
        </div>
      </GlucoseProvider>
    </LanguageProvider>
  );
}

export default App;
